import React from 'react';

import { eventJournalSortStorageKey } from '@entities/eventJournal/model/globals';
import { useEventsSort } from '@features/JournalSortFilter/lib/hooks';
import { saveToLocalStorage } from '@shared/helpers';
import { Dropdown, FilterContainer, Icon } from '@shared/ui';

import cls from './JournalSortFilter.module.css';

export const JournalSortFilter = () => {
    const {
        t,
        sortBtnRef,
        sortQueryValue,
        setSortQueryState,
        handleCloseDropdown,
        handleFilterContainerClick,
        handleToggleDropdown,
        isOpen,
    } = useEventsSort();
    return (
        <div className={cls.SortWrapper}>
            <FilterContainer
                onClick={handleFilterContainerClick}
                innerRef={sortBtnRef}
                // isHovered={isOpen || !!sortQueryValue}
                isHovered={isOpen}
            >
                <Icon iconName="sort" height={14} width={14} />
                <span className={cls.SortTitle}>{t('JournalEvents.Filters.Sort')}</span>
            </FilterContainer>
            <Dropdown
                isOpen={isOpen}
                onClose={handleCloseDropdown}
                buttonRef={sortBtnRef}
                className={cls.DropdownContainer}
            >
                <Dropdown.List>
                    <Dropdown.ListItem
                        onClick={() => {
                            handleToggleDropdown();
                            void setSortQueryState('asc');
                            saveToLocalStorage(eventJournalSortStorageKey, 'asc');
                        }}
                        className={sortQueryValue === 'asc' ? cls.Active : ''}
                    >
                        {t('JournalEvents.Filters.Asc')}
                    </Dropdown.ListItem>
                    <Dropdown.ListItem
                        onClick={() => {
                            handleToggleDropdown();
                            void setSortQueryState('desc');
                            saveToLocalStorage(eventJournalSortStorageKey, 'desc');
                        }}
                        className={sortQueryValue === 'desc' ? cls.Active : ''}
                    >
                        {t('JournalEvents.Filters.Desc')}
                    </Dropdown.ListItem>
                </Dropdown.List>
            </Dropdown>
        </div>
    );
};
